import { action, atom, withAssign } from '@reatom/framework'

import type { TableData } from './reatom-data-table-state'

export type TablePagination = {
  limit: number
  offset: number
  cursor: string | undefined
}

export const reatomDataTablePagination = ({ limit }: { limit: number }) => {
  const paginationAtom = atom<TablePagination>(
    {
      limit,
      offset: 0,
      cursor: undefined,
    },
    'paginationAtom',
  )
  const hasMoreItemsAtom = atom(false, 'hasMoreItemsAtom')

  const resetAction = action((ctx) => {
    paginationAtom(ctx, {
      limit,
      offset: 0,
      cursor: undefined,
    })
    hasMoreItemsAtom(ctx, true)
  }, 'resetAction')

  const handleDataAction = action(
    (ctx, data: TableData<object>, { offset }: { offset?: number }) => {
      if (typeof data.hasNext === 'boolean') {
        hasMoreItemsAtom(ctx, data.hasNext)
      } else {
        hasMoreItemsAtom(ctx, data.data.length >= limit)
      }

      paginationAtom(ctx, {
        limit,
        offset: offset ?? 0,
        cursor: data.cursor,
      })
    },
    'handleDataAction',
  )

  return paginationAtom.pipe(
    withAssign(() => ({
      reset: resetAction,
      handleData: handleDataAction,
      hasMoreItems: hasMoreItemsAtom,
    })),
  )
}
